import React from 'react';
import BarSplitChart from './BarSplitChart';

const CommodityCodeSplitChart = () => (
  <BarSplitChart
    title="Split Over Commodity Code"
    endpoint="/dashboard/commodity-code-split"
    cornerLabel="descending"
    barColor="var(--dash-chart-6)"
    maxRows={7}
  />
);

export default CommodityCodeSplitChart;
